import { createFileRoute } from '@tanstack/react-router';
import { ProtectedPage } from '../app/route-boundaries';
import { AdminCommercePage } from '../pages/AdminCommercePage';
export const Route = createFileRoute('/app/commerce')({ validateSearch: (search: Record<string, unknown>) => ({ app_id: typeof search['app_id'] === 'string' ? search['app_id'] : undefined }), component: () => <ProtectedPage><AdminCommercePage /></ProtectedPage> });
